export const INITIAL_STUDENT_FILTER = {
	grade: [],
	location: [],
	dorm: [],
	gender: [],
	type: []
}

export const INITIAL_LEAVE_FILTER = {
	students: [],
	actors: [],
	type: [],
	leaveBy: [],
	returnBy: [],
	leaveAt: null,
	returnAt: null
}
